import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  isMax: boolean
  onClick: () => void
} & ClassNameProps

export const AmountMaxButton: React.FC<Props> = ({
  isMax,
  onClick,
  className,
}) => {
  const { t } = useTranslation()

  return (
    <Root className={className} $active={isMax} onClick={onClick} type="button">
      {t('common.max')}
    </Root>
  )
}

const Root = styled.button<{ $active: boolean }>`
  all: unset;
  cursor: pointer;
  height: 22px;
  display: grid;
  align-items: center;
  justify-content: center;
  padding-inline: 8px;
  font-weight: 700;
  font-size: 11px;
  line-height: 1;
  color: var(--text-12);

  cursor: pointer;

  text-transform: uppercase;
  border-radius: 16px;

  ${({ $active }) => {
    if (!$active) {
      return css`
        background: var(--background-9);
      `
    }
    return css`
      background: var(--blue-9);
      box-shadow: 0px 0px 24px 0px rgba(38, 137, 235, 0.75);
    `
  }}
`
